import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import { environment } from '@env/environment';
import { AdminSessionService } from '@core/auth/admin-session.service';
import { APP_CONFIG } from '@core/config/app-config.token';
import { GlobalErrorHandler } from '@core/errors/global-error-handler';
import { provideGraphql } from '@core/graphql/graphql.provider';
import { authInterceptor } from '@core/http/auth.interceptor';
import { errorInterceptor } from '@core/http/error.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    { provide: APP_CONFIG, useValue: environment },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideRouter(routes, withComponentInputBinding(), withPreloading(PreloadAllModules)),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, errorInterceptor])),
    provideGraphql(),
    // Starts the silent token refresh for a session rehydrated from sessionStorage.
    provideAppInitializer(() => {
      inject(AdminSessionService);
    }),
  ],
};
